export default "__VITE_ASSET__D5$3K8SI__"